import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { useProfileData } from "../../../hooks/useProfileData";
import { getInteractions } from "../../services/entities";
import { Interaction } from "../../../types";

type InteractionsResponse = {
  data: Interaction[];
  message: string;
};

type UseInteractionsResult = {
  interactionsData: InteractionsResponse | undefined;
  isInteractionsDataLoading: boolean;
  isInteractionsDataHasError: boolean;
};

export const useInteractions = (duration: string): UseInteractionsResult => {
  const { i18n } = useTranslation();
  const { data: userData, isLoading: isUserDataLoading } = useProfileData();
  const entityId = userData?.entityId;

  const {
    data: interactionsData,
    isLoading: isInteractionsDataLoading,
    isError: isInteractionsDataHasError,
  } = useQuery<InteractionsResponse>({
    queryKey: ["Dashboard", "Interactions", i18n.language, entityId, duration],
    queryFn: async () => await getInteractions(entityId, duration),
    enabled: !!entityId,
  });

  return {
    interactionsData,
    isInteractionsDataLoading: isInteractionsDataLoading || isUserDataLoading,
    isInteractionsDataHasError,
  };
};
